module.exports = createReactClass;